import React, { createContext, useEffect } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { darkModeAtom, toggleDarkModeAtom } from '../Services/store/atoms';

const DarkModeContext = createContext();

export const DarkModeProvider = ({ children }) => {
    const [darkMode] = useAtom(darkModeAtom);
    const toggleDarkMode = useSetAtom(toggleDarkModeAtom);

    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }

        // theme-color venía fijo en negro en index.html, sin importar el modo.
        // Safari/Chrome usan este meta para pintar su propia UI (barra de
        // direcciones, la píldora compacta al hacer scroll en iOS) — lo
        // sincronizamos con el mismo fondo que ya usa la app (--sb-body-bg
        // en index.html) para que esa UI del navegador combine con el tema
        // actual en vez de quedar siempre en blanco/negro fijo.
        const themeColorMeta = document.querySelector('meta[name="theme-color"]');
        if (themeColorMeta) {
            themeColorMeta.setAttribute('content', darkMode ? '#0f172a' : '#f8f8f8');
        }

        let style = document.getElementById('sb-style');
        if (!style) {
            style = document.createElement('style');
            style.id = 'sb-style';
            document.head.appendChild(style);
        }
        if (darkMode) {
            style.textContent = `
                ::-webkit-scrollbar-track { background: #1e293b !important; }
                ::-webkit-scrollbar-thumb { background: #64748b !important; border-radius: 6px !important; min-height: 40px !important; }
                ::-webkit-scrollbar-thumb:hover { background: #94a3b8 !important; }
            `;
        } else {
            style.textContent = `
                ::-webkit-scrollbar-track { background: #e2e8f0 !important; }
                ::-webkit-scrollbar-thumb { background: #94a3b8 !important; border-radius: 6px !important; min-height: 40px !important; }
                ::-webkit-scrollbar-thumb:hover { background: #64748b !important; }
            `;
        }
    }, [darkMode]);

    return (
        <DarkModeContext.Provider value={{ darkMode, toggleDarkMode }}>
            {children}
        </DarkModeContext.Provider>
    );
};

export default DarkModeContext;